import { SeoSlugEnum, SERVICE_TYPE_FOR_SEO_SLUG } from '@rover/constants/src/search/seo.constants';
import type { OptimizedSearchResponse } from '@rover/rsdk/src/apiClient/latest/model/optimizedSearchResponse';
import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';
import { PetType } from '@rover/types/src/Pet';
import {
  PET_TYPE_FOR_SERVICE_LANDING_ENUM,
  ServiceLandingEnum,
} from '@rover/types/src/ServiceLanding';

import { LandingSearchFormFilters } from '../components/LandingSearchForm';

export const getSearchFiltersFromSearchResults = (
  serviceLandingType: ServiceLandingEnum,
  searchResults?: OptimizedSearchResponse
): LandingSearchFormFilters => {
  const filters: LandingSearchFormFilters = {
    serviceType: SERVICE_TYPE_FOR_SEO_SLUG[serviceLandingType],
    locationType: searchResults?.derivedData?.zipCode ? 'zip-code' : undefined,
    location: searchResults?.derivedData?.zipCode as string,
    centerlat: searchResults?.derivedData?.center
      ? searchResults?.derivedData?.center[0]
      : undefined,
    centerlng: searchResults?.derivedData?.center
      ? searchResults?.derivedData?.center[1]
      : undefined,
    petType: PET_TYPE_FOR_SERVICE_LANDING_ENUM[serviceLandingType],
  };

  if (serviceLandingType === ServiceLandingEnum.PUPPY_BOARDING) {
    filters.puppy = true;
  }

  return filters;
};

export function getSearchFiltersFromSeoLocationDetails(
  seoLocation: SeoLocation
): LandingSearchFormFilters {
  const { localityType, details: seoLocationDetails } = seoLocation;

  return {
    serviceType: SERVICE_TYPE_FOR_SEO_SLUG[seoLocationDetails.serviceTypeSlug],
    locationType: localityType,
    location: seoLocationDetails.locality.seoDisplayName,
    centerlat: parseFloat(seoLocationDetails.locality.latitude),
    centerlng: parseFloat(seoLocationDetails.locality.longitude),
    petType: [
      seoLocationDetails.serviceTypeSlug === SeoSlugEnum.CAT_SITTING ? PetType.CAT : PetType.DOG,
    ],
    // Send the page's own SEO slug so search resolves the location via the fast,
    // cached slug path instead of re-resolving the free-text `location` string.
    // The form clears it if the user edits location or service (see LandingSearchForm).
    seoLocationSlug: seoLocationDetails.searchParams.seoLocationSlug,
  };
}
